import { render, staticRenderFns } from "./GroupSubscriptionView.vue?vue&type=template&id=d4c9d4e4&scoped=true&"
import script from "./GroupSubscriptionView.vue?vue&type=script&lang=js&"
export * from "./GroupSubscriptionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c9d4e4",
  null
  
)

export default component.exports